<div  
  id="container" 
  class="engine"
  [class.engine--checkered]="isBackgroundCheckered"
  [ngStyle]="getContainerStyles()"
  #engine >
  <canvas id="theCanvas" class="engine__canvas" #engineCanvas></canvas>
  <canvas id="annotationCanvas" class="engine__annotations" #engineAnnotations></canvas>  
  <app-labels></app-labels>

  <!-- input blocking -->
  <div *ngIf="!inputEnabled" class="engine__input-blocking"></div>
  
  <app-engine-progress></app-engine-progress>

  <app-engine-scroll></app-engine-scroll>
</div>